/** @format */

import { useContext, useMemo, useEffect, useState } from "react";
import { Context } from "../stores/Provider";
import { GetMethod } from "../api/Api";
import useNavigateByAgent from "./useNavigateByAgentHooks";
import { getSession, setSession } from "../sessionStorage/sessionStorageMethod";
import { setSessionByResponse, setIsLoading } from "../function";
import {
  successApiResponseType,
  entrySelectRequestType,
  getEntryHistoryRequestType,
  getEntryHistoryResponseType,
  loginResponseStatus,
} from "../@types";
import { logoutAbnormalFunction } from "../function/logoutAbnormalFunction";
import { initApiModelType, loginResponseDataType } from "../constance/typeModel";
import { initApiResponse, zAccountNameObj } from "../constance/constance";

const useEntrySelectHooks = () => {
  const { state, dispatch } = useContext(Context);
  const { navigateByAgent } = useNavigateByAgent();

  const isRegisterBtnShowFlag = useMemo(() => state.zAccount === "ocnk", [state.zAccount]);
  const zAccountName = useMemo(() => zAccountNameObj[state.zAccount], [state.zAccount]);
  const userInfoData = getSession("user");
  const [entryInfoData, setEntryInfoData] = useState<any>(null);

  useEffect(() => {
    // ブラウザリロードするとお申し込み履歴取得処理が2回実行されてしまう事象の対策
    if (!state.zAccount) return;

    const getResponse = async () => {
      setIsLoading(true, dispatch);
      const requestParameter = { user_id: userInfoData.user_id, z_account: state.zAccount };
      let response: initApiModelType<getEntryHistoryResponseType> = initApiResponse;
      response = await GetMethod<getEntryHistoryRequestType, getEntryHistoryResponseType>(
        requestParameter,
        "/get_entry_history",
      );
      if (response.code === 200 && response.response_data) {
        setSession("entry", response.response_data.entry_infos);

        setEntryInfoData(response.response_data.entry_infos);
      } else {
        if (response.code === 401) {
          return logoutAbnormalFunction(response, dispatch, navigateByAgent, state.agentPath, state.zAccount);
        }
        setIsLoading(false, dispatch);
        return navigateByAgent("/system_error");
      }

      setIsLoading(false, dispatch);
    };

    getResponse();
  }, [state.zAccount, userInfoData.user_id]);

  const GetEntryInfo = async (entry_id: number) => {
    setIsLoading(true, dispatch);
    const response = await GetMethod<entrySelectRequestType, loginResponseDataType>(
      { entry_id: entry_id },
      "/get_entry_info",
    );
    return response;
  };

  const entrySelectNormal = (response: successApiResponseType<loginResponseDataType>) => {
    setSessionByResponse(dispatch, state.agentPath, state.zAccount, response);

    const statusData = response.response_data.status;

    if (typeof statusData !== "string") {
      const userStatus = statusData as loginResponseStatus;
      let closeScheduleDate = calculateCloseScheduleDate(
        userStatus.confirm_date ? new Date(userStatus.confirm_date).toISOString() : null,
      );

      dispatch({
        type: "set-context-data",
        payload: {
          user_status: {
            status: userStatus.status,
            close_schedule_date: closeScheduleDate,
            before_status: userStatus.before_status,
            confirm_flag: userStatus.confirm_flag,
            cancel_flag: userStatus.cancel_flag,
            economic_condition_confirmed_flag: userStatus.economic_condition_confirmed_flag,
          },
        },
      });
    }
    return navigateByAgent("/dashboard");
  };

  const entrySelectAbnormal = () => {
    return navigateByAgent("/entry_select");
  };

  const calculateCloseScheduleDate = (confirmDate: string | null) => {
    if (!confirmDate) return null;

    try {
      const isoDateStr = confirmDate.replace(" ", "T");
      const date = new Date(isoDateStr);

      if (isNaN(date.getTime())) return null;

      date.setDate(date.getDate() + 30);

      return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
    } catch (e) {
      return null;
    }
  };

  return {
    entryInfoData,
    GetEntryInfo,
    entrySelectNormal,
    entrySelectAbnormal,
    isRegisterBtnShowFlag,
    zAccountName,
  };
};

export default useEntrySelectHooks;
